module.exports = __webpack_public_path__ + "static/img/huaweiP40Pro.334a5f1e.png";